
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { formatValue } from '@/utils/format';
import IconButton from '@/components/shared/suites/IconButton.vue';
import Tooltip from '@/components/shared/Tooltip.vue';
import TextField from '@/components/shared/TextField.vue';


@Component<Pricing>({
	components: {
		IconButton,
		Tooltip,
		TextField
	}
})
export default class Pricing extends Vue {
	@Prop({ type: Array, default: () => [] }) private pricingItems!: Option[];
	@Prop({ type: String, default: true }) private toolTipText!: '';
	@Prop({ type: Boolean, default: false }) private disabled!: boolean;
	@Prop({ type: Boolean, default: false }) private isItemPriceOnRequest!: boolean;
	@Getter('getPriceAffixes', { namespace: 'auth' }) private priceAffixes!: PriceAffixes;

	private get pricingArray() {
		if (this.disabled) {
			return this.pricingItems.filter((item: any) => (item.price));
		}
		return this.pricingItems;
	}

	private formatPricingItemPrice = (price: any) => formatValue(price, '', 'price');

	private formatPricingItemCalories = (calories: number) => formatValue(calories, null, 'calories');

	private addAddOnForm () {
		this.$emit('add-pricing-item');
	}

	private removeAddOnForm (index: number) {
		this.$emit('remove-pricing-item', index);
	}
}
